// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2a2f4998","455":"4ff85229","977":"a43dd8f4"}[chunkId] + ".chunk.js";
};